import { selectCurrentlyApplicableContentTypes } from '~src/spacesPlatform/selectors/ContentFilterSelectors';
import { selectDisplaySettings } from '~src/spacesPlatform/selectors/DisplaySettingsSelectors';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { SpaceInfo, SpaceType, SubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import { DisplayMode } from '../../sessionManagement/serverApi/types/ISessionInfo';
import { ExplorableItemType } from '../../spacesPlatform/models/ContentType';
import { ValidTelemetryEvent } from '../services/Telemetry';

export type ExplorerEventContentType = ExplorableItemType | 'mixed';

export type ExplorerEventInfo =
  {
    space: SpaceType;
    subspace: SubspaceName;
    contentType: ExplorerEventContentType;
    displayMode: DisplayMode;
  };

/**
 * populates the space, subspace and contentType information for telemetry events
 */
export function CreateExplorerEvent<T extends ValidTelemetryEvent>(event: T): T & ExplorerEventInfo {
  const appState = getAppStore().getState();
  const spaceInfo: SpaceInfo = selectSpaceInfo(appState);
  const contentTypes: ReadonlyArray<ExplorableItemType> = selectCurrentlyApplicableContentTypes(appState);
  const displayMode: DisplayMode = selectDisplaySettings(appState).explorerDisplayMode;

  return {
    space: spaceInfo.spaceType,
    subspace: spaceInfo.subspaceName,
    contentType: contentTypes.length !== 1 ? 'mixed' : contentTypes[0],
    displayMode: displayMode,
    ...event
  };
}
